import Axios from "axios";
import {
  ApiBaseUrl,
  PBIReportBaseUrl,
  SupplierNoticeBaseUrl,
} from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  AddPbiReportGroupRequest,
  AddPbiReportGroupResponse,
  AddPbiReportRequest,
  EditPbiReportGroupsRquest,
  EditPbiReportRequest,
  GETReports,
  GetGroupsWithSubReportsResponse,
  GetPbiReportGroupsRequest,
  GetPbiReportsResponse,
  GroupIdRequest,
  GroupResponse,
  PBIReportResponse,
} from "../models/pBIReport.model";

export const GetPBIReports = (): Promise<PBIReportResponse[]> => {
  return Axios.get<ApiResultModel<PBIReportResponse[]>>(
    ApiBaseUrl + PBIReportBaseUrl + "/GetPBIReports"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetGroup = (): Promise<GroupResponse[]> => {
  return Axios.get<ApiResultModel<GroupResponse[]>>(
    ApiBaseUrl + PBIReportBaseUrl + "/GetGroup"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetReportsByGroup = (
  request: GroupIdRequest
): Promise<ApiResultModel<PBIReportResponse[]>> => {
  return Axios.post<ApiResultModel<PBIReportResponse[]>>(
    ApiBaseUrl + PBIReportBaseUrl + "/GetReportsByGroup",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetGroupsWithSubReports = (): Promise<GetGroupsWithSubReportsResponse[]> => {
  return Axios.get<ApiResultModel<GetGroupsWithSubReportsResponse[]>>(
    ApiBaseUrl + PBIReportBaseUrl + "/GetGroupsWithSubReports"
  ).then((result) => {
    return result.data.data;
  });
};

export const AddPbiReportGroup = async (
  data: AddPbiReportGroupRequest
): Promise<AddPbiReportGroupResponse> => {
  return await Axios.post<ApiResultModel<AddPbiReportGroupResponse>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/AddPbiReportGroup",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const EditPbiReportGroups = async (
  data: EditPbiReportGroupsRquest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/EditPbiReportGroups",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPbiReportGroups = async (
  data: GetPbiReportGroupsRequest
): Promise<AddPbiReportGroupResponse[]> => {
  return await Axios.post<ApiResultModel<AddPbiReportGroupResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/GetPbiReportGroups",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeletePbiReportGroups = async (data: {
  id: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/DeletePbiReportGroups",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const DeletePbiReport = async (data: {
  pbiReportId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/DeletePbiReport",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPbiReports = async (data: {
  pbiReportId?: number;
}): Promise<GetPbiReportsResponse[]> => {
  return await Axios.post<ApiResultModel<GetPbiReportsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/GetPbiReports",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const EditPbiReport = async (
  data: EditPbiReportRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/EditPbiReport",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const AddPbiReport = async (
  data: AddPbiReportRequest
): Promise<GETReports> => {
  return await Axios.post<ApiResultModel<GETReports>>(
    // SERVIES_URL
    ApiBaseUrl + PBIReportBaseUrl + "/AddPbiReport",
    data
  ).then((result) => {
    return result.data.data;
  });
};
